// extracted by mini-css-extract-plugin
export default {"cell-container":"DetailsRow_cell-container__rmCW1","accordion-content-container":"DetailsRow_accordion-content-container__JaGou","clickable":"DetailsRow_clickable__i+1yK"};